var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M8.75 10H4.167m-.07.243L2.15 16.055c-.153.457-.23.685-.175.826a.42.42 0 0 0 .276.25c.146.04.365-.059.804-.256l13.927-6.267c.428-.193.643-.29.709-.423a.416.416 0 0 0 0-.37c-.066-.134-.28-.23-.71-.423L3.053 3.123c-.438-.197-.657-.295-.802-.255a.417.417 0 0 0-.276.25c-.056.14.02.367.171.823l1.952 5.88c.026.079.039.118.044.158a.417.417 0 0 1 0 .107.878.878 0 0 1-.045.157Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBarIcon);
export default __webpack_public_path__ + "static/media/search-bar-icon.83b28347ac858233328c2e85464f1e77.svg";
export { ForwardRef as ReactComponent };